<ix-widget-pool
  *ngIf="!(isLoading$ | async)"
  ixDrag
  [showReorderHandle]="showReorderHandle"
  [poolState]="poolState$ | async"
  [volumeData]="volumeData$ | async"
  (back)="onMobileBack()"
>
  <span ixDragHandle></span>
</ix-widget-pool>
